<template>
  <div v-if="rendered">
    <el-dialog
      :title="resource.image_uploader_dialog_title"
      :visible.sync="dialogVisible"
      size="small"
      custom-class="fullimagedialog" append-to-body>
      <el-tabs v-model="activeTabName">
        <el-tab-pane
          :label="resource.custom_image_upload_title"
          name="customUpload">
          <custom-image-uploader :event-bus="eventBus" :show-save.sync="showSaveButton" :show-back.sync="showBackButton" v-if="activeTabName === 'customUpload' && !isMultipleFileAllow">
          </custom-image-uploader>
          <custom-multiple-image-uploader :event-bus="eventBus" :show-save.sync="showSaveButton" :show-back.sync="showBackButton" :isMultipleFileAllow="isMultipleFileAllow" v-if="activeTabName === 'customUpload' && isMultipleFileAllow">
          </custom-multiple-image-uploader>
        </el-tab-pane>
        <el-tab-pane :label="resource.str_pixabay" name="pixabay" v-if="!isMultipleFileAllow">
          <pixabay-picker :event-bus="eventBus" :show-save.sync="showSaveButton" :show-back.sync="showBackButton" v-if="activeTabName === 'pixabay'">
          </pixabay-picker>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" align="middle">
          <el-col :span="12" align="left">
            <el-button
              v-show="showBackButton"
              @click="eventBus.$emit('backClick')"
              type="text"
              size="small">{{resource.pixbayback}}</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="hideGalleryClick">{{resource.cancelupload}}</el-button>
            <el-button
              @click="eventBus.$emit('saveImage')"
              v-if="showSaveButton"
              type="primary">{{resource.saveimage}}</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import CustomImageUploader from './CustomImageUploader'
import CustomMultipleImageUploader from './CustomMultipleImageUploader'
import PixabayPicker from './Pixabay'
import Cropper from '../Cropper'

export default {
  components: {
    CustomImageUploader,
    CustomMultipleImageUploader,
    PixabayPicker,
    Cropper
  },
  data () {
    return {
      imageSrc: '',
      showBackButton: false,
      showSaveButton: false,
      activeTabName: 'customUpload',
      eventBus: new Vue()
    }
  },
  computed: {
    ...mapGetters(['resource']),
    ...mapGetters('imageGallery', [ 'visible', 'rendered', 'extraArguments' ]),
    dialogVisible: {
      get () {
        this.resetBacknSaveButton()
        return this.visible
      },
      set (value) {
        if (!value) {
          this.activeTabName = 'customUpload'
          this.eventBus.$emit('backClick')
          this.hideGallery()
        }
      }
    },
    isMultipleFileAllow () {
      return this.extraArguments.isMultipleFileAllow ? this.extraArguments.isMultipleFileAllow : false
    }
  },
  created () {
    this.eventBus.$on('image-selected', this.onImageSelected)
    this.eventBus.$on('images-selected', this.onImagesSelected)
  },
  beforeDestroy () {
    this.eventBus.$off('image-selected', this.onImageSelected)
    this.eventBus.$off('images-selected', this.onImagesSelected)
  },
  methods: {
    ...mapActions('imageGallery', [
      'hideGallery',
      'uploadImage',
      'uploadImages'
    ]),
    async onImageSelected (imageData) {
      this.$showLoader()
      await this.uploadImage(imageData)
      this.activeTabName = 'customUpload'
      this.$hideLoader()
    },
    async onImagesSelected (imageDataArray) {
      this.$showLoader()
      imageDataArray.map((image) => {
        delete image.imagePreview
        return image
      })
      await this.uploadImages(imageDataArray)
      this.activeTabName = 'customUpload'
      this.$hideLoader()
    },
    hideGalleryClick () {
      this.resetBacknSaveButton()
      this.activeTabName = 'customUpload'
      this.hideGallery()
    },
    resetBacknSaveButton () {
      this.showBackButton = false
      this.showSaveButton = false
      this.eventBus.$emit('backClick')
    }
  }
}
</script>

<style>
.fullimagedialog {
    width: 900px;
    height: 600px;
    padding: 0 20px;
}
.fullimagedialog .el-dialog__body {
    padding: 20px;
}
.fullimagedialog .el-dialog__title {
  font-size: 24px;
  font-weight: normal;
}
.fullimagedialog .el-tabs__content {
  height: 390px;
}
.fullimagedialog .el-tab-pane {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/ImageGallery/Dialog.vue